import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Table, TableColumnsType } from 'antd';
import Title from 'antd/es/typography/Title';
import { getAdjustPlanPeriod } from 'app/entities/common/common.reducer';
import { getEntities as getContributions, updateEntity } from 'app/entities/contribution/contribution.reducer';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { displayPercent, formatPoint, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import { Container } from 'reactstrap';
import { contributionView, contributionViewType } from '../config';
import TotalContribution from './total-contribution';
import * as _ from 'lodash';
import TextArea from 'antd/es/input/TextArea';

type IAdjustWeightProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
};

export const AdjustWeight = ({ isOpen, onClose }: IAdjustWeightProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const [payload, setPayload] = useState<any[]>([]);

  const contributionList = useAppSelector(state => state.contribution.entities);
  const expandLoading = useAppSelector(state => state.contribution.loading);
  const filterObjectives = useAppSelector(state => state.filters.objective);
  const adjustPlanPeriods = useAppSelector(state => state.common.adjustmentPlanPeriod);

  const updating = useAppSelector(state => state.contribution.updating);
  const [filter, setFilter] = useState<any>({
    contributionViewType: 1,
  });
  const [contributionGroupBy, setContributionGroupBy] = useState(null);
  const [isOpenModalTotalContribution, setOpenModalTotalContribution] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);



  const createPurposeColumns = (): TableColumnsType<any> => {
    if (filterObjectives?.planPeriodType === PlantPeriodType.Quarter) {
      return [
        {
          title: 'Mục tiêu và KR cả năm',
          fixed: 'left',
          key: 'purposeYear',
          width: 250,
          render: (_, record) => <span className={`${!record?.objectiveId ? '' : ''}`}>{record?.purposeYear ?? record?.purpose}</span>,
        },
        {
          title: 'KR quý',
          fixed: 'left',
          key: 'purposeQuarter',
          width: 250,
          // Dòng mục tiêu không hiển thị để tránh trùng lặp
          render: (_, record) => (record?.objectiveId ? <span>{record?.purposeQuarter}</span> : null),
        },
      ];
    }

    if (filterObjectives?.planPeriodType === PlantPeriodType.Month) {
      return [
        {
          title: 'Mục tiêu và KR cả năm',
          fixed: 'left',
          key: 'purposeYear',
          width: 250,
          render: (_, record) => <span className={`${!record?.objectiveId ? '' : ''}`}>{record?.purposeYear ?? record?.purpose}</span>,
        },
        {
          title: 'KR quý',
          fixed: 'left',
          key: 'purposeQuarter',
          width: 250,
          // Dòng mục tiêu không hiển thị để tránh trùng lặp
          render: (_, record) => (record?.objectiveId ? <span>{record?.purposeQuarter}</span> : null),
        },
        {
          title: 'KR tháng',
          fixed: 'left',
          key: 'purposeMonth',
          width: 250,
          // Dòng mục tiêu không hiển thị để tránh trùng lặp
          render: (_, record) => (record?.objectiveId ? <span>{record?.purposeMonth}</span> : null),
        },
      ];
    }

    return [
      {
        title: 'Mục tiêu và kết quả then chốt',
        fixed: 'left',
        key: 'purpose',
        width: 250,
        render: (_, record) => <span className={`${!record?.objectiveId ? '' : ''}`}>{record?.purpose}</span>,
      },
    ];
  };

  const metaColumns: TableColumnsType<any> = [
    {
      title: 'Mã',
      fixed: 'left',
      key: 'code',
      width: 100,
      dataIndex: 'code',
    },
    // {
    //   title: 'Lĩnh vực',
    //   key: 'fieldName',
    //   width: 120,
    //   dataIndex: 'fieldName',
    //   fixed: 'left',
    // },
    // {
    //   title: 'Dự án',
    //   key: 'projectName',
    //   width: 120,
    //   dataIndex: 'projectName',
    //   fixed: 'left',
    // },
    // {
    //   title: 'Mảng công việc',
    //   key: 'workTypeName',
    //   dataIndex: 'workTypeName',
    //   width: 120,
    //   fixed: 'left',
    // },
  ];

  const weightColumns: TableColumnsType<any> = [
    {
      title: 'Tỷ trọng mục tiêu (theo KH)',
      key: 'oldContribution',
      width: 100,
      dataIndex: 'oldContribution',
      render: item => item && formatPoint(item),
    },
    {
      title: 'Tỷ trọng KR (theo KH)',
      width: 100,
      key: 'oldContributionKr',
      dataIndex: 'oldContributionKr',
      render: item => item && formatPoint(item),
    },
    {
      title: 'Tỷ trọng mục tiêu (Cập nhật)',
      key: 'contribution',
      width: 150,
      render: (index, item) =>
        !item.objectiveId && (
          <InputNumber
            min={0}
            step={0.01}
            precision={2}
            formatter={formatNumber}
            parser={parseNumber}
            disabled={!item.editable}
            onChange={value => {
              handleChangeWeight(value, item);
            }}
            value={item.contribution}
          />
        ),
    },
    {
      title: 'Tỷ trọng KR (Cập nhật)',
      width: 150,
      key: 'contributionKr',
      render: (index, item) =>
        item.objectiveId ? (
          <InputNumber
            min={0}
            formatter={formatNumber}
            parser={parseNumber}
            step={0.01}
            precision={2}
            disabled={!item.editable}
            onChange={value => {
              handleChangeWeight(value, item);
            }}
            value={_.isInteger(item.contributionKr) ? item.contributionKr : item.contributionKr?.toFixed(2)}
          />
        ) : (
          <span>
            {_.isInteger(
              _.sumBy(item.children, (o: any) => {
                return o.contributionKr;
              }),
            )
              ? _.sumBy(item.children, (o: any) => {
                return o.contributionKr;
              })
              : _.sumBy(item.children, (o: any) => {
                return o.contributionKr ?? 0;
              }).toFixed(2)}
          </span>
        ),
    },
    {
      title: 'Lý do điều chỉnh',
      width: 200,
      key: 'adjustmentReason',
      render: (index, item) => (
        <TextArea
          rows={1}
          disabled={!item.editable}
          onChange={value => {
            handleChangeReason(value, item);
          }}
          value={item.adjustmentReason}
        />
      ),
    },
  ];

  const purposeColumns = createPurposeColumns();
  const columns: TableColumnsType<any> = [...metaColumns, ...purposeColumns, ...weightColumns];
  const expandIconColumnIndex = metaColumns.length;

  useEffect(() => {
    dispatch(getAdjustPlanPeriod({ planPeriodId: filterObjectives?.planPeriodId }));
  }, [isOpen]);

  useEffect(() => {
    if (adjustPlanPeriods && adjustPlanPeriods.length > 0) {
      setFilter({ ...filter, adjustmentPeriod: adjustPlanPeriods[0].value })
    }
  }, [adjustPlanPeriods])

  useEffect(() => {
    if (filterObjectives && filterObjectives?.planPeriodId) {
      const newFilter = { ...filter, planPeriodId: filterObjectives?.planPeriodId, accountableId: filterObjectives?.accountableId };
      setFilter(newFilter);
    }
  }, [filterObjectives]);

  useEffect(() => {
    if (filter?.planPeriodId && filter?.adjustmentPeriod != null) {
      dispatch(getContributions(filter));
    }
  }, [filter]);


  useEffect(() => {
    if (contributionList && contributionList.length > 0) {
      const allRowKeys = getAllRowKeys(contributionList);
      setExpandedRowKeys(allRowKeys);
      setPayload(
        contributionList.map(x => {
          return {
            ...x,
            contribution: x.contribution ? displayPercent(x.contribution) : 0,
            keyResults: x.keyResults.map(y => {
              return {
                ...y,
                contributionKr: y.contributionKr ? displayPercent(y.contributionKr) : 0,
              };
            }),
          };
        }),
      );
    } else {
      setPayload([]);
    }
  }, [contributionList]);

  const getAllRowKeys = item => {
    return item.reduce((keys, value) => {
      keys.push(value.id);

      if (value.keyResults) {
        keys = keys.concat(getAllRowKeys(value.keyResults));
      }

      return keys;
    }, []);
  };

  const handleChangeWeight = (value, item) => {
    if (payload.length > 0) {
      const newPayload = payload.map(x => {
        return {
          ...x,
          contribution: item.id === x.id ? value : x.contribution,
          keyResults: x.keyResults.map(y => {
            return {
              ...y,
              contributionKr: y.id === item.id ? value : y.contributionKr,
            };
          }),
        };
      });
      setPayload(newPayload);
    }
  };

  const handleChangeReason = (e, item) => {
    if (payload.length > 0) {
      const newPayload = payload.map(x => {
        return {
          ...x,
          adjustmentReason: item.id === x.id ? e.target.value : x.adjustmentReason,
          keyResults: x.keyResults.map(y => {
            return {
              ...y,
              adjustmentReason: y.id === item.id ? e.target.value : y.adjustmentReason,
            };
          }),
        };
      });
      setPayload(newPayload);
    }
  };

  const handleSubmit = () => {
    const requestPayload = payload.map(x => {
      return {
        id: x.id,
        planPeriodId: filter?.planPeriodId,
        adjustmentPeriod: filter?.adjustmentPeriod,
        contribution: percent(x.contribution),
        adjustmentReason: x.adjustmentReason,
        keyResults: x.keyResults.map(y => {
          return {
            id: y.id,
            contribution: percent(y.contributionKr),
            adjustmentReason: y.adjustmentReason,
          };
        }),
      };
    });
    dispatch(updateEntity(requestPayload)).then(res => {
      if (res && res.payload) {
        handleClose(true);
      }
    }).catch(er => {
      return;
    });
  };

  const handleClose = (reload = false) => {
    onClose(reload);
  };

  const handleChangeContributionViewType = value => {
    const newFilter = { ...filter, contributionViewType: value };
    setFilter(newFilter);
  };

  const handleViewTotalContribution = value => {
    setContributionGroupBy(value);
    setOpenModalTotalContribution(true);
  };

  const handleCloseTotalContribution = () => {
    setOpenModalTotalContribution(false);
  };

  const handleChangeAdjustPlanPeriods = value => {
    const newFilter = { ...filter, adjustmentPeriod: value };
    setFilter(newFilter);
  };

  return (
    <Modal
      width={1300}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
          <Row>
            <Title level={3}>{`Cân đối tỷ trọng ${filterObjectives?.accountableName ? `- ${filterObjectives?.accountableName}` : ''}`}</Title>
          </Row>
          <Row className='mb-3'>
            <Col md={2}>
              <Input className="w-100" disabled value={filterObjectives?.planPeriodName} />
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Select
                className="w-100"
                value={filter?.adjustmentPeriod}
                options={adjustPlanPeriods}
                onChange={handleChangeAdjustPlanPeriods}
                filterOption={filterOption}
                allowClear
                placeholder="Chọn kỳ điều chỉnh"
                size="large"
              />
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Select
                className="w-100"
                value={filter?.contributionView}
                options={contributionView}
                placeholder="Xem tổng tỷ trọng"
                filterOption={filterOption}
                onChange={handleViewTotalContribution}
                size="large"
              />
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Select
                className="w-100"
                value={filter?.contributionViewType}
                options={contributionViewType}
                filterOption={filterOption}
                onChange={handleChangeContributionViewType}
                size="large"
              />
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item>
                <Table
                  expandable={{
                    expandedRowKeys,
                    onExpandedRowsChange(newExpandedRowKeys: any) {
                      setExpandedRowKeys(newExpandedRowKeys);
                    },
                    expandIconColumnIndex, // đặt icon tại cột đầu tiên của phần mục tiêu/KR
                  }}
                  bordered
                  dataSource={payload.map(x => {
                    return {
                      key: x.id,
                      ...x,
                      children: x.keyResults?.map(y => {
                        return {
                          key: y.id,
                          ...y,
                        };
                      }),
                    };
                  })}
                  tableLayout='fixed'
                  scroll={{ y: `60vh` }}
                  loading={expandLoading}
                  pagination={false}
                  summary={pageData => {
                    let totalContribution = 0;

                    pageData.forEach(({ children, contribution }) => {
                      totalContribution += contribution ?? 0;
                    });
                    return (
                      <Table.Summary fixed>
                        <Table.Summary.Row className="fw-bold">
                          <Table.Summary.Cell colSpan={metaColumns.length + purposeColumns.length} index={0}>
                            Tổng cộng
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1} />
                          <Table.Summary.Cell index={2} />
                          <Table.Summary.Cell index={3}>
                            <span>{`${totalContribution}%`}</span>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={4} />
                          <Table.Summary.Cell index={5} />
                        </Table.Summary.Row>
                      </Table.Summary>
                    );
                  }}
                  columns={columns}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Row className="action" justify="end">
              <Col>
                <Button type="primary" htmlType="submit" disabled={updating || payload.length <= 0}>
                  Lưu
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Hủy
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
        {isOpenModalTotalContribution && (
          <TotalContribution
            filter={filter}
            isOpen={isOpenModalTotalContribution}
            contributionGroupBy={contributionGroupBy}
            onClose={handleCloseTotalContribution}
          />
        )}
      </Container>
    </Modal>
  );
};

export default AdjustWeight;
